var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveTickets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 15",
    filter: "url(#filter0_d_5642_16238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 71,
    height: 71,
    rx: 35.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5 50.5C32.2956 50.5 33.0587 50.1839 33.6213 49.6213C34.1839 49.0587 34.5 48.2956 34.5 47.5V38.5C34.5 36.5109 35.2902 34.6032 36.6967 33.1967C38.1032 31.7902 40.0109 31 42 31C43.9891 31 45.8968 31.7902 47.3033 33.1967C48.7098 34.6032 49.5 36.5109 49.5 38.5V52.75C49.5 53.1478 49.342 53.5294 49.0607 53.8107C48.7794 54.092 48.3978 54.25 48 54.25H45.33C45.0682 53.7966 44.6924 53.4196 44.2398 53.1564C43.7871 52.8933 43.2735 52.7532 42.75 52.75C41.9544 52.75 41.1913 53.0661 40.6287 53.6287C40.0661 54.1913 39.75 54.9544 39.75 55.75C39.75 56.5456 40.0661 57.3087 40.6287 57.8713C41.1913 58.4339 41.9544 58.75 42.75 58.75C43.2735 58.7468 43.7871 58.6067 44.2398 58.3436C44.6924 58.0804 45.0682 57.7034 45.33 57.25H48C49.1935 57.25 50.3381 56.7759 51.182 55.932C52.0259 55.0881 52.5 53.9435 52.5 52.75V50.5C53.6935 50.5 54.8381 50.0259 55.682 49.182C56.5259 48.3381 57 47.1935 57 46V43C57 41.8065 56.5259 40.6619 55.682 39.818C54.8381 38.9741 53.6935 38.5 52.5 38.5C52.5 35.7152 51.3938 33.0445 49.4246 31.0754C47.4555 29.1062 44.7848 28 42 28C39.2152 28 36.5445 29.1062 34.5754 31.0754C32.6062 33.0445 31.5 35.7152 31.5 38.5C30.3065 38.5 29.1619 38.9741 28.318 39.818C27.4741 40.6619 27 41.8065 27 43V46C27 47.1935 27.4741 48.3381 28.318 49.182C29.1619 50.0259 30.3065 50.5 31.5 50.5Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.5 44.5C38.3284 44.5 39 43.8284 39 43C39 42.1716 38.3284 41.5 37.5 41.5C36.6716 41.5 36 42.1716 36 43C36 43.8284 36.6716 44.5 37.5 44.5Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42 44.5C42.8284 44.5 43.5 43.8284 43.5 43C43.5 42.1716 42.8284 41.5 42 41.5C41.1716 41.5 40.5 42.1716 40.5 43C40.5 43.8284 41.1716 44.5 42 44.5Z",
    fill: "#3BBEE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.5 44.5C47.3284 44.5 48 43.8284 48 43C48 42.1716 47.3284 41.5 46.5 41.5C45.6716 41.5 45 42.1716 45 43C45 43.8284 45.6716 44.5 46.5 44.5Z",
    fill: "#3BBEE8"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5642_16238",
    x: 0,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.745098 0 0 0 0 0.909804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5642_16238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5642_16238",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTickets);
export default __webpack_public_path__ + "static/media/activeTickets.a5bd301e1faf25654add44e187c1264c.svg";
export { ForwardRef as ReactComponent };